import dynamic from 'next/dynamic'
import {baseGetServerSideProps} from 'utils/server/defaultGetServerSideProps'

import {Page} from '@vio/core/src/analytics/types/Events'

const Alerts = dynamic(
  () =>
    /* webpackPrefetch: true */
    import('views/alerts'),
  {ssr: false}
)

export default Alerts

export const getServerSideProps = baseGetServerSideProps({
  page: Page.AlertManagement
})
